import { useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { PageHeader, Btn, Field, Input } from "@/components/ui-kit";

export default function Settings() {
  const { user } = useAuth();
  const tenant = user?.tenant;
  const [pwd, setPwd] = useState({ current_password: "", new_password: "" });
  const [msg, setMsg] = useState(null);

  const changePwd = async (e) => {
    e.preventDefault();
    setMsg(null);
    try {
      await api.post("/auth/change-password", pwd);
      setMsg({ type: "ok", text: "Password updated successfully." });
      setPwd({ current_password: "", new_password: "" });
    } catch (e2) {
      setMsg({ type: "err", text: e2.response?.data?.detail || "Failed to update password" });
    }
  };

  return (
    <div data-testid="settings-page">
      <PageHeader title="Settings" subtitle="Company profile, account credentials, and preferences." />
      <div className="grid lg:grid-cols-2 gap-6">
        <div className="bg-white border border-zinc-200 rounded-lg p-6">
          <div className="font-display font-bold text-asphalt mb-4">Company Details</div>
          <div className="space-y-3 text-sm">
            <Row label="Company" value={tenant?.company_name} />
            <Row label="Owner" value={tenant?.owner_name} />
            <Row label="Email" value={tenant?.email} />
            <Row label="Mobile" value={tenant?.mobile || "—"} />
            <Row label="GSTIN" value={tenant?.gst_number || "—"} />
            <Row label="Status" value={tenant?.status} />
          </div>
          <div className="mt-5 text-xs text-zinc-500">To update company details, please email support@webcabz.in (KYC change protocol).</div>
        </div>

        <div className="bg-white border border-zinc-200 rounded-lg p-6">
          <div className="font-display font-bold text-asphalt mb-4">Change Password</div>
          <form onSubmit={changePwd} className="space-y-3">
            <Field label="Current password" required><Input type="password" value={pwd.current_password} onChange={(e) => setPwd({...pwd, current_password: e.target.value})} required data-testid="settings-current-pwd" /></Field>
            <Field label="New password" required hint="Minimum 6 characters"><Input type="password" value={pwd.new_password} onChange={(e) => setPwd({...pwd, new_password: e.target.value})} required minLength={6} data-testid="settings-new-pwd" /></Field>
            {msg && <div className={`text-sm px-3 py-2 rounded-md ${msg.type === "ok" ? "bg-emerald-50 text-emerald-700" : "bg-red-50 text-red-700"}`}>{msg.text}</div>}
            <Btn type="submit" data-testid="settings-pwd-save">Update password</Btn>
          </form>
        </div>
      </div>
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div className="flex items-start justify-between border-b border-zinc-100 pb-2 last:border-0">
      <div className="text-xs uppercase tracking-wider text-zinc-500">{label}</div>
      <div className="text-asphalt font-medium">{value || "—"}</div>
    </div>
  );
}
